var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.366,
    height: 27.365,
    viewBox: "0 0 27.366 27.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in-2",
    "data-name": "Icon awesome-linkedin-in",
    d: "M6.126,27.366H.452V9.1H6.126ZM3.286,6.6A3.3,3.3,0,1,1,6.571,3.286,3.313,3.313,0,0,1,3.286,6.6ZM27.36,27.366H21.7V18.472c0-2.12-.043-4.838-2.95-4.838-2.95,0-3.4,2.3-3.4,4.685v9.047H9.679V9.1h5.441v2.492H15.2a5.961,5.961,0,0,1,5.368-2.95c5.742,0,6.8,3.781,6.8,8.692V27.366Z",
    transform: "translate(0 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a6161b1b2a063cc037b76bd8161779ef.svg";
export { ForwardRef as ReactComponent };